import {Controller} from "stimulus"
import $ from 'jquery';

import 'toastr/toastr.scss'
import {get_popup} from "./popup_controller";
import {blockBody} from "./blockUI_controller";

import Swal from 'sweetalert2/dist/sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
// import '@sweetalert2/themes/default/default.scss';

import {set_locale} from './localize_controller'
import sessionStorage_controller, {
    setSessionVar,
    checkSessionVar,
    checkSessionVarWithData
} from './sessionStorage_controller'
import {get_modalities} from './rentaContractModalityTariff_controller'
import {validate, validate_email} from "./validate_controller";

import {check_time_reservation} from "./alert_controller";
import {get_authenticated_user_data, verification, verify_user} from "./verificaciones_controller";
import {confirm_cart, loaded} from "./swal_controller";
import bootbox from "bootbox";

export default class extends Controller {

    static values = {
        url: String
    }

    connect() {
        let inPayProcess = sessionStorage.getItem('inPayProccess');
        let payment_url = sessionStorage.getItem('payment_url');

        $(document).ready(function() {
            if (inPayProcess === 'true') {
                $('#dropdown-buttons').empty();
                $('#dropdown-buttons').css('justify-content', 'center');
                $('#dropdown-buttons').append(`
                    <a id="reservation_cancel" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px" data-action="setValue#cancel_reservation">
                    <span class="fa fa-times"></span>Cancelar</a>
                    <a href="${payment_url}" class="btn btn-outline-warning btn-sm" style="margin-right: 5px">
                    <i class="fa fa-shopping-cart"></i>${I18n.t('main.header.shopping_cart.process_btn')}</a>
                `)
            }
        })
    }
}